import React from "react";

function IllustrationTimeToSell() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 104 96">
      <path
        d="M45.289 69.847l23.442-23.601-5.103-5.103L45.289 59.64l-5.103-5.103-5.103 5.103s7.655 7.495 10.206 10.206z"
        className="fill-primary"
      />
      <path
        d="M103.654 19.455V8.292c0-2.71-2.073-4.784-4.784-4.784H85.635V1.595c0-.479-.16-.798-.479-1.117C84.996.16 84.518 0 84.2 0h-3.508c-.478 0-.797.16-1.116.478-.32.32-.479.638-.479 1.117v1.913H24.877V1.595c0-.479-.16-.798-.478-1.117C23.92.16 23.6 0 23.123 0h-3.508c-.479 0-.798.16-1.117.478-.319.32-.478.638-.478 1.117v1.913H4.784C2.074 3.508 0 5.581 0 8.292V91.216C0 93.926 2.073 96 4.784 96H98.87c2.711 0 4.784-2.073 4.784-4.784v-71.76zM3.189 8.292c0-.956.638-1.594 1.595-1.594H17.86V8.77c0 .478.16.797.479 1.116.319.319.638.478 1.116.478h3.509c.478 0 .797-.159 1.116-.478.319-.319.478-.638.478-1.116V6.698h54.22V8.77c0 .478.159.797.478 1.116.319.319.638.478 1.116.478h3.508c.479 0 .798-.159 1.117-.478.319-.319.478-.638.478-1.116V6.698H98.87c.957 0 1.595.638 1.595 1.594v9.568H3.189V8.292zm97.276 82.924c0 .957-.638 1.595-1.595 1.595H4.784c-.957 0-1.595-.638-1.595-1.595V21.05h97.276v70.166z"
        className="fill-secondary"
      />
    </svg>
  );
}

export default IllustrationTimeToSell;
